import { WUJI_HOST } from '@/config/app/domain';
import { ENV } from '@/infrastructure/env-config';

const wujiEnv = ENV.isProd ? 'prod' : 'test';

export default {
  wujiDashboardUser: `${WUJI_HOST}/xy/app/${wujiEnv}/bugly_report/dashboard`,
  wujiDashboardProject: `${WUJI_HOST}/xy/app/${wujiEnv}/bugly_report/dashboard`,
};
